<template>
    <div>
      <div class="form-container ou-donation-form jlic-donation-form">
        <div class="holder">
          <PaymentForm class="form-horizontal">
            <FormSection title="Donation Amount:">
              <AmountSelectorList :nocustom="true"/>
              <ErrorLabel field="amount" />
              <TransactionFee />
            </FormSection>
            <!-- <FormSection title="Donation Frequency:">
              <div class="frequency">
                <PaymentOptions addSplit addMonthly monthlyText="Monthly" />
              </div>
            </FormSection> -->
            <FormSection title="Your Details">
              <FormRow inline>
                <FormCol field="title" :flex="1" />
                <FormCol field="firstName" :flex="2" />
                <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                <FormCol field="email" />
                <FormCol field="phone" />
              </FormRow>
              <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>               
              <br />
              <InHonorOf />
            </FormSection>
            <FormSection title="Billing Information">
              <DonorAddress />
            </FormSection>
            <FormSection title="Payment Information" last>       
              <FormRow inline>
                <FormCol field="card" :showLabel="false" />
              </FormRow>
            </FormSection>
            <PaymentButton showAmount btnText="Donate" />
          </PaymentForm>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  import { usePaymentForm } from "~/shared/use-payment-form";
  import { queryParams } from "~/shared/query-params";
  
  export default defineComponent({
    setup() {
      const { setValue, form } = usePaymentForm();
  
      const params = queryParams();

  
  
      return {
        form,
        setValue,
      };
    },
  });
  </script>
  <style scoped lang="scss">
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }
  
  

  ::v-deep input#amount_other {
  margin-left: auto !important;
    font-size: 14px !important;
    padding-bottom: 0px !important;
    max-width: 227px !important;
    width: 100%;
}
  </style>
  